import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { HeaderDivider } from "../../../utilities/utll";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";

const mockData = [
  {
    serialNo: 1,
    isChecked: false,
    storeCode: "20003",
    itemCode: "114469747",
    itemDesc: "TATA SAMPANN URAD DAL WHOLE 500G",
    businessDesc: "Pulses",
    division: "Grocery",
    market: "Staples",
    category: "Dal",
    family: "Urad",
    actualShelfDays: 120,
    oneSixthShelfDays: 20,
    stockOnHand: 15,
    grnQty: 20,
    grnDate: "2025-01-05",
    expiryDate: "2025-03-30",
    expiryQty: 13,
    scanQty: 1,
    scanDate: "2025-01-20",
    scanBy: "Admin",
  },
  {
    serialNo: 2,
    isChecked: false,
    storeCode: "20005",
    itemCode: "114469888",
    itemDesc: "FORTUNE SUNFLOWER OIL 1L",
    businessDesc: "Edible Oil",
    division: "Grocery",
    market: "Oil",
    category: "Cooking Oil",
    family: "Sunflower",
    actualShelfDays: 180,
    oneSixthShelfDays: 30,
    stockOnHand: 25,
    grnQty: 30,
    grnDate: "2025-01-02",
    expiryDate: "2025-06-15",
    expiryQty: 10,
    scanQty: 0,
    scanDate: "",
    scanBy: "Admin",
  },
];

const BasicGrid = ({ gridData, setGridData }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { expiryListApprove } = useNearToExpiryStore();

  const headerCheckboxRef = useRef(null);
  console.log("expiryListApprove", gridData);

useEffect(() => {
  if (Array.isArray(expiryListApprove)) {
    setGridData(
      expiryListApprove.map((item, index) => ({
        ...item,
        serialNo: index + 1,
        isChecked: false,

        // ✅ convert string → Date
        ScanOn: item.ScanOn ? new Date(item.ScanOn) : null,
        ApprovedOn: item.ApprovedOn ? new Date(item.ApprovedOn) : null,
        ExpiryDate: item.ExpiryDate ? new Date(item.ExpiryDate) : null,
        ManufacturingDate: item.ManufacturingDate
          ? new Date(item.ManufacturingDate)
          : null,
      }))
    );
  }
}, [expiryListApprove]);
  useEffect(() => {
    if (!headerCheckboxRef.current) return;

    const pendingRows = gridData.filter((r) => r.ApprovedStatus === "Pending");

    const checkedCount = pendingRows.filter((r) => r.isChecked).length;

    headerCheckboxRef.current.checked =
      pendingRows.length > 0 && checkedCount === pendingRows.length;

    headerCheckboxRef.current.indeterminate =
      checkedCount > 0 && checkedCount < pendingRows.length;
  }, [gridData]);

  const headerCheckboxTemplate = () => (
    <input
      type="checkbox"
      ref={headerCheckboxRef}
      onChange={(e) => {
        e.stopPropagation();
        const checked = e.target.checked;

        setGridData((prev) =>
          prev.map((row) =>
            row.ApprovedStatus === "Pending"
              ? { ...row, isChecked: checked }
              : row,
          ),
        );
      }}
    />
  );

  console.log("gridData in grid", gridData);

  const checkboxTemplate = (props) => {
    if (props.ApprovedStatus !== "Pending") {
      return null; // Approved / Rejected → no checkbox
    }

    return (
      <input
        type="checkbox"
        checked={props.isChecked}
        onChange={(e) => {
          e.stopPropagation();
          setGridData((prev) =>
            prev.map((row) =>
              row.ID === props.ID
                ? { ...row, isChecked: e.target.checked }
                : row,
            ),
          );
        }}
      />
    );
  };

  const scanQtyTemplate = (props) => {
    const [localValue, setLocalValue] = useState(props.ScanQty ?? "");

    return (
      <input
        type="number"
        value={localValue}
        style={{ width: "60px" }}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={() => {
          setGridData((prev) =>
            prev.map((row) =>
              row.ID === props.ID
                ? { ...row, ScanQty: Number(localValue) }
                : row,
            ),
          );
        }}
      />
    );
  };
  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };
  const rowDataBound = (args) => {
    if (args.data?.ApprovedStatus === "Pending") {
      args.row.style.backgroundColor = "#dde2ce";
      args.row.style.color = "#AD4E00";
      args.row.style.fontWeight = "500";
    }
  };
  return (
    <>
        <div
          className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
          style={{
            position: "relative",
            marginTop: "10px",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            padding: "6px",
            marginBottom: "20px",
          }}
        >
          <Row>
            <Col>
              <GridComponent
                ref={(g) => (gridInstance = g)}
                id="BrokerGrid"
                dataSource={gridData}
                allowPaging={true}
                allowSorting={true}
                allowFiltering={true}
                filterSettings={{ type: "Excel" }}
                toolbar={["ExcelExport", "Search"]}
                allowExcelExport={true}
                toolbarClick={toolbarClick}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
                gridLines="Both"
                height={"300px"}
                pageSettings={{
                  pageSizes: [10, 20, 30, 40, 50, "All"],
                  pageCount: 10,
                }}
                rowHeight={isMobile ? "" : 32}
                frozenColumns={1}
                allowResizing={true}
                dataBound={() => {
                  if (!isMobile && gridInstance) {
                    gridInstance.autoFitColumns();
                  }
                }}
                rowDataBound={rowDataBound}
                // rowDataBound={()}
                // commandClick={handleCommandClick}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="serialNo"
                    headerText="S No"
                    width="90"
                    textAlign="Center"
                    allowFiltering={false}
                  />
                  <ColumnDirective
                    field="ID"
                    headerText="Id"
                    width="90"
                    textAlign="Center"
                    visible={false}
                  />
                  <ColumnDirective
                  field="isChecked"
                    width="80"
                    template={checkboxTemplate}
                    headerTemplate={headerCheckboxTemplate}
                  />
                  <ColumnDirective
                    field="PopulatedDate"
                    headerText="PopulatedDate"
                    type="date"
                    format="dd/MM/yyyy"
                    width="190"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="LocationCode"
                    headerText="Store Code"
                    width="190"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="StoreName"
                    headerText="Store Name"
                    width="190"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DivisionName"
                    headerText="Division Name"
                    width="190"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DepartmentName"
                    headerText="Department Name"
                    width="200"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ArticleCode"
                    headerText="Item Code"
                    width="250"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ShortDesc"
                    headerText="Short Desc"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="EanPlu"
                    headerText="Ean Plu"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="StockOnHand"
                    headerText="Stock On Hand"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ManufacturingDate"
                    headerText="Manufacturing Date"
                    type="date"
                    format="dd/MM/yyyy"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ExpiryType"
                    headerText="Expiry Type"
                    width="220"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ExpiryQty"
                    headerText="Expiry Qty"
                    width="230"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ExpiryDate"
                    headerText="Expiry Date"
                    type="date"
                    format="dd/MM/yyyy"
                    width="200"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="MRP"
                    headerText="MRP"
                    width="160"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="CSP"
                    headerText="CSP"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ScanQty"
                    headerText="Scan Qty"
                    width="170"
                    textAlign="center"
                    template={scanQtyTemplate}
                  />
                  <ColumnDirective
                    field="ApprovedQty"
                    headerText="Approved Qty"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ScanBy"
                    headerText="Scan By"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ScanOn"
                    headerText="Scan On"
                    type="date"
                    format="dd/MM/yyyy"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ApprovedStatus"
                    headerText="Approved Status"
                    width="170"
                    textAlign="Left"
                  />

                  <ColumnDirective
                    field="ApprovedBy"
                    headerText="Approved By"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ApprovedOn"
                    headerText="Approved On"
                    type="date"
                    format="dd/MM/yyyy"
                    width="170"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="Discount"
                    headerText="Discount"
                    width="170"
                    textAlign="Left"
                  />
                  {/*
                <ColumnDirective
                  field="UploadedOn"
                  headerText="UploadedOn"
                  type="date"
                  format="dd/MM/yyyy"
                  width="170"
                  textAlign="Left"
                /> */}
                </ColumnsDirective>

                <Inject
                  services={[
                    CommandColumn,
                    Page,
                    Filter,
                    Toolbar,
                    ExcelExport,
                    Sort,
                    Group,
                    Resize,
                    Freeze,
                  ]}
                />
              </GridComponent>
            </Col>
          </Row>
        </div>
    </>
  );
};

export default BasicGrid;
